import React from 'react';

import Subheader from '@/components/Subheader';
import { SUBNAVIGATION_CAROUSEL_ID } from '@/model/constants';

interface SubNavigationPropTypes {
  onMenuItemClick?: (args: { path: string; itemTitle: string }) => void;
  items: {
    title: string;
    route_link: string;
    type: string;
    state: string;
  }[];
  initialScrollValue?: number;
  isSubNavigation?: boolean;
}

const Navigation = ({
  items,
  onMenuItemClick,
  initialScrollValue,
  isSubNavigation = true,
}: SubNavigationPropTypes) => {
  const menuItems = items.map(item => {
    return {
      title: item.title,
      type: item.type,
      state: item.state,
      route_link: item.route_link,
    };
  });

  const handleMenuClick = (menuItem: {
    type: string;
    index: number;
    title: string;
  }) => {
    const { index } = menuItem;
    const { route_link } = menuItems[index];

    onMenuItemClick &&
      onMenuItemClick({ path: route_link, itemTitle: menuItem.title });
  };

  let initialScroll =
    initialScrollValue !== undefined
      ? {
          position: initialScrollValue,
          name: SUBNAVIGATION_CAROUSEL_ID,
        }
      : undefined;

  return (
    <Subheader
      items={menuItems}
      onClick={handleMenuClick}
      navHorizontalPadding={10}
      initialScroll={initialScroll}
      isSubNavigation={isSubNavigation}
    />
  );
};

export default Navigation;
